import { useTranslate } from "@tolgee/react";
import { Button } from "#/components/ui/button.tsx";
import { useWallet } from "#/hooks/use-wallet";
import { cn } from "#/lib/utils";
import type { OrderSide } from "./constants/order-form.constants.ts";

type Props = {
	submitLabel: string;
	side: OrderSide;
	canSubmit: boolean;
	onSubmit: () => void;
};

export function OrderSubmitButton({
	submitLabel,
	side,
	canSubmit,
	onSubmit,
}: Props) {
	const { t } = useTranslate();
	const { isConnected, isReady, connect } = useWallet();

	const label = t(isConnected ? submitLabel : "actions.login");

	const onClickSubmit = () => {
		if (!isConnected) {
			connect("trade_cta");
			return;
		}

		onSubmit();
	};

	return (
		<Button
			disabled={!isReady || (isConnected && !canSubmit)}
			aria-busy={!isReady}
			className={cn(
				"mt-auto min-h-9 w-full rounded-[8px] text-label1-bold text-trade-accent-text transition-[filter,transform] hover:brightness-105 sm:min-h-10.5 sm:rounded-[9px] sm:text-body1-bold",
				isConnected &&
					side === "buy" &&
					"bg-primary shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] hover:bg-primary text-primary-foreground",
				isConnected &&
					side === "sell" &&
					"bg-trade-red shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] hover:bg-trade-red text-[var(--color-theme-static-white)]",
				!isConnected && "text-primary-foreground",
			)}
			onClick={onClickSubmit}
		>
			{label}
		</Button>
	);
}
